import React from "react";
import { Link } from "react-router-dom";
import Footer from "components/Footers/Footer.js";
import Navbar from "components/Navbars/IndexNavbar.js";
export default function Careers(){
    return(
        <>
         <Navbar transparent />
        <div class="header relative pt-16 items-center flex h-screen max-h-860-px" id="cara">
            <iframe id="iframe-container-1" width="100%" frameborder="0" height="300" margin-top="50px" src="https://widget.recooty.com/openings.php?key=38d914e960ed48c110fa9197175fd086"></iframe>
        </div>

<Footer/>
        </>
    );
}